import { initializeApp } from 'firebase/app'
import { getFirestore , addDoc, doc, deleteDoc, updateDoc, increment, documentId, serverTimestamp,setDoc, orderBy ,query, where, collection, getDocs} from 'firebase/firestore'
import { getAuth , deleteUser , updatePassword , sendPasswordResetEmail} from 'firebase/auth'
import {getStorage , deleteObject,ref , uploadBytes, getDownloadURL,} from 'firebase/storage'

// import {functions} from 'firebase/functions'; // Add this for callable functions

import Papa from 'papaparse';
import {month } from '../constants/hor-th'
import Rasee from '../data/rasee.json'

const firebaseConfig = {
  apiKey: "AIzaSyBLLen2y9FfM_SoTjgyqogHKTOwHCNQqNk",
  authDomain: "hor-th.web.app",
  projectId: "hor-th",
  storageBucket: "hor-th.firebasestorage.app",
  messagingSenderId: "256625107373",
  appId: "1:256625107373:web:fcefc6e1b41a0d6bd58124",
  measurementId: "G-0QLWSZHEXV"
};
const app = initializeApp(firebaseConfig)
export const db = getFirestore(app)
export const authUser = getAuth(app)
const storage = getStorage(app)
export { storage, ref, uploadBytes, deleteObject,getDownloadURL }
// If you are using a different region for your functions
// functions.useRegion('asia-southeast1'); // Example

// export const functions = firebase.functions() // Get the functions instance

//  export const googleMapApiKey= 'AIzaSyChfMusRyXTeN11PyREyY2p_P8LaONJFDo'  // project id : conex-a535b
// export const googleMapApiKey= 'AIzaSyCd-qv9-Wciodcem4bRrB8TIxSJtREi3W0'  // project id : conex-432423

export const offsetMinLoc =async( pBD)=>{
  const q = query(collection(db,'placeBD'), where ("id", "==", pBD))
  const QuerySnapshot = await getDocs(q) 
  const offset = QuerySnapshot.docs.map((item) => {
    let d = item.data() 
    let osMin = parseInt(d.offsetMin) + parseInt( d.offsetSec)/60
    return  osMin.toFixed(3)                    
  })  
  return offset[0]
}
export const createNewUserWallet =async(amount, userId) =>{
  let walletData = {
      userId : userId,
      balanced : amount,
      timestamp : serverTimestamp()
  }
  try {
      await setDoc(doc(db, `Wallet`, userId), walletData, {merge : true})
  } catch (e) {
      console.error("Error on create new user's wallet: ", e);
  }               
}


export const getBalance =async(userId, callback)=>{
  const q = query(collection(db,'Wallet'), where ("userId", "==", userId))
  const walletQuerySnapshot = await getDocs(q) 
  const bal = walletQuerySnapshot.docs.map((item) => {
      return item.data().balanced                       
  })  
  callback(bal[0])   
}
export const userInfoByUserId= async(userId, cb)=>{
  const q = query(collection(db, "Users"), 
  where("userId", "==", userId)
  );
  const querySnapshot = await getDocs(q);
  const user = querySnapshot.docs.map((doc) => {
    let d=doc.data()
    return {
      name : d.name,
      phone : d.phone,      
      userCat : d.userCat,
      email : d.email,      
    }
  })
  cb(user[0])
}
export const getDocById = async(colName, fieldName, id, cb)=>{
  const q = query(collection(db, colName), 
  where(fieldName, "==", id)
  );
  const querySnapshot = await getDocs(q);
  const user = querySnapshot.docs.map((doc) => {
    return doc.data()
  })
  cb(user)
}
export const verifyExstFC = async( userId ,fcId , cb)=>{
  const q = query(collection(db, 'uaTx'), 
  where('payerId', "==", userId),
  where('reason', "==", fcId)
  );
  const querySnapshot = await getDocs(q);
  const d = querySnapshot.docs.map((doc) => {
    return doc.data().slipId
  });
 cb(d)
}

export const getDataWithDocId = async(collectionName, docId, cb)=>{
  const q = query(collection(db, collectionName), 
    where(documentId(), "==", docId)
  );
  const querySnapshot = await getDocs(q);
  const data = querySnapshot.docs.map((doc) => {
    return doc.data()
  });
  cb(data)
}
export const getAllMembers = async(cb)=>{
  const q = query(collection(db, "Users"), 
    where("userCat", "==", "member")
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    let d = doc.data()
    return {
      userId : d.userId,
      name : d.name,
      email: d.email
    }
  });
  cb(list)
}
export const getCalendarWithDate = async(date)=>{
  const q = query(collection(db, "Calendar"), 
    where("date", "==", date)
  );
  const querySnapshot = await getDocs(q);
  const clndr = querySnapshot.docs.map((doc) => {
    let d = doc.data()
    // let date = d.date.split('-')
    // let mnDate = d.mnDate.split('-')
    // let moon = d.moon.split('-')
    let sun = d.sun.split('-')
    return {
      // ausMin : d.ausMin,
      // day : date[0],
      // month: date[1],
      // year : date[2],
      // upRam: mnDate[1],
      // upRamAt: mnDate[2],      
      // mnMth: mnDate[3],
      // dithyMin:d.dithyMin,
      // mnMv: d.mnMv == "*" ? "" : d.mnMv,
      // mnRs : moon[0],
      // mnDeg : moon[1],
      // mnLda : moon[2],
      snRs : sun[0],
      snDeg : sun[1],
      snLda : sun[2],
      // dateTS : new Date(`${date[2]-543}/${date[1]}/${date[0]}`).valueOf()
    }
  });
  return clndr[0]
}
export const getCalendar = async(yearBE, cb)=>{
  const q = query(collection(db, "Calendar"), 
    where("year", "==", yearBE)
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    let d = doc.data()
    let date = d.date.split('-')
    // let mnDate = d.mnDate.split('-')
    // let moon = d.moon.split('-')
    let sun = d.sun.split('-')
    // let dithyMn = d.dithyMin.split('-')[0]
    // let dithyMin = d.dithyMin.split('-')[1]
    // let ausMn = d.ausMin.split('-')[0]
    // let ausMin = d.ausMin.split('-')[1]
    // let mnMv = d.mnMv == "*" ? "" : `${d.mnMv.split('.')[0]}:${d.mnMv.split('.')[1]}`
    return {
      clndrId: doc.id,
      // ausMn : ausMn,
      // ausMin : ausMin,
      day : date[0],
      month: date[1],
      year : date[2],
      // dayNum: mnDate[0],
      // upRam: mnDate[1],
      // upRamAt: mnDate[2],      
      // mnMth: mnDate[3],
      // dithyMn: dithyMn,
      // dithyMin: dithyMin,
      // mnMv: mnMv,
      // mnRs : moon[0],
      // mnDeg : moon[1],
      // mnLda : moon[2],
      snRs : sun[0],
      snDeg : sun[1],
      snLda : sun[2],
      dateTS : new Date(`${date[2]-543}/${date[1]}/${date[0]}`).valueOf()
    }
  });
  cb(list)
}

export const uaTxWallet = async( cost, userId, slipId, paymentMethod, acctType, reason )=>{
  await sumUpWallet(cost, userId)
  const uaTx = {
      slipId : slipId,
      payerId : userId,        
      paymentMethod : paymentMethod,
      amount : cost,
      acctType : acctType,
      reason : reason,
      timestamp : new Date().valueOf()
  }
  await saveWithId('uaTx', uaTx.slipId, uaTx)
}
export const saveWithId = async(collection, id , payload)=>{
  await setDoc(doc(db, collection, id), payload , {merge : true});
}
export const getRefillSlip = async( startAt, endAt, cb)=>{
  const q = query(collection(db, "uaTx"),
    where('timestamp', '>=' , startAt),  
    where('timestamp', '<=' , endAt),
    where("acctType", "in", ["refillCC" , "refill" ,"adjust" , "refillOL"])
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    let d = doc.data()
    return {
      date : new Date(d.timestamp),
      ...d
    }
  })
  cb(list)
}

export const getNameUserId= async( userId )=>{
  const q = query(collection(db, "Users"), 
    where(documentId(), "==", userId)
  );
  const querySnapshot = await getDocs(q);
  const name = querySnapshot.docs.map((doc) => {
    return doc.data().name
  });
  return name[0]
}

export const getWalletData = async( cb)=>{
  let wData = []
  const querySnapshot = await getDocs(collection(db, "Wallet"));
  querySnapshot.forEach(async(doc) => {
    let d = doc.data()
    wData.push({
      userName : await getNameUserId(d.userId),
      ...d
    })
  });
  cb(wData)
}

export const getForecastHalfMthlyTbl = async(cb)=>{
  const querySnapshot = await getDocs(collection(db, "ForecastHM"));
  const list = querySnapshot.docs.map((doc) => {
     let fcId = doc.id
     let fc = doc.data()
     return {
      fcId : fcId,
      lrs : `${Rasee.data[parseInt(fcId.slice(6,8))].rsTH}`,
      year : `${fcId.slice(0,4)} /${parseInt(fcId.slice(0,4))-543}`,
      month : `${month[(parseInt(fcId.slice(4,6)-1))]}`,
      halfType : `${fcId.slice(8,9)}`,
      fileUrl : fc.fileUrl,
      dateTS : fc.ts
    }
  });
  cb(list)
}

export const deleteItem = async( coltn, id)=>{
  await deleteDoc(doc(db, coltn, id))
}

export const sumUpWallet =async(amount, userId) =>{
  if (!isNaN(amount)) {
    try {
      await updateDoc(doc(db, 'Wallet', userId), { 
        balanced: increment(amount),
        timestamp: new Date().valueOf()
      });
    } catch (e) {
        console.error("Error sumUp Wallet: ", e);
    } 
  }

}

export const mergeCSV = (collectionName, csvFile , cb)=>{
  // Read CSV data using PapaParse
  Papa.parse(csvFile, {
    header: true,
    complete: (results) => {
      // Upload data to Cloud Firestore
      results.data.forEach(async(item) => {
        const docRef = await addDoc(collection(db, collectionName),item)
          // console.log('Document written with ID:', docRef.id);
      });
    }
  });
  cb('success')
}

export const getPlaceList = async(cb)=>{
  const q = query(collection(db, "placeBD"), orderBy("id" , "asc"))
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    let d = doc.data()
    return {
      value : d.id,
      text : d.pvTH
    }
  });
  cb(list)
}

export const changePassword = async(password , cb)=>{ 
  await updatePassword(authUser.currentUser, password).then(() => {
    cb( "success")
  }).catch((err) => {
    console.log(`changePassword error : !${err}`)
    cb ("failed")
  });
}
export const passwordResetEmail = async(email , cb)=>{ 
  await sendPasswordResetEmail(authUser, email).then(() => {
    cb( "success")
  }).catch((err) => {
    console.log(`resetPassword error code: ${err.code}`)
    cb (err.code)
  });
}
export const changeName = async(userId ,name , cb)=>{
  await updateDoc(doc(db, "Users", userId), { name: name}).then(()=>{
    cb ("success")
  }).catch((err)=>{
    cb ("failed")
  })
}

export const changePhone = async(userId ,phone, cb)=>{
  await updateDoc(doc(db, "Users", userId), { phone: phone}).then(()=>{
    cb ("success")
  }).catch((err)=>{
    cb ("failed")
  })
}

export const deleteAccount = async(userId, cb)=>{   
    await deleteUser(authUser.currentUser).then(() => {
      cb ("success")
    }).catch((err)=>{
      console.log(`updateUsersActive to False, error : !${err}`)
      cb ("failed")
    })
}

export const userListAll = async(cb)=>{
  const q = query(collection(db, "Users")
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    return doc.data()
  });
  cb(list)
}

